import { emitDatadogAction, emitDatadogTiming } from "@faire/web--source/common/datadog/rum";
import { getTraceTiming } from "../../pete/TraceEventUtils";
export var datadogInterceptor = function(params) {
    if (!params.realTimeTracking) {
        return;
    }
    try {
        var context = {
            faire: {
                pete: params.parameters
            }
        };
        emitDatadogAction("faire.pete.".concat(params.eventKey), context);
        if (params.sourceEventKey) {
            var timing = getTraceTiming(params.sourceEventKey, params.sourceEventMarker);
            emitDatadogTiming("faire.pete.".concat(params.eventKey), timing);
        }
    } catch (_) {
    /* ignore */ }
};
